
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nuestras-webs",
      function () {
        return require("private-next-pages/nuestras-webs/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nuestras-webs"])
      });
    }
  